/* @flow */
import * as React from 'react';
import Link from 'components/Link';
import Image from 'components/Image';
import MediaObject from 'components/MediaObject';
import Row from 'components/Row';

type PartnerIntegrationProps = {
  organizationUUID: string,
  onClick: Function,
  integration: any,
};

const PartnerIntegration = (props: PartnerIntegrationProps) => {
  const { integration } = props;
  const { iconURL, title } = integration;

  return (
    <Link onClick={props.onClick} color="inherit">
      <Row size="small">
        <MediaObject center gutter="small">
          <div className="AdminIntegratedToolsView-partner-logo">
            <Image src={iconURL} />
          </div>
          <div>{title}</div>
        </MediaObject>
      </Row>
    </Link>
  );
};

export default PartnerIntegration;
